<template>
  <div id="container">
    <div
      v-if="!mobile"
      class="q-pa-xs items-center justify-center row col-12"
      id="desktop"
    >
      <main class="base">
        <header class="row headerBase">
          <q-img
            v-if="$store.state.autenticacao.logo.logoImpressao"
            :src="$store.state.autenticacao.logo.logoImpressao"
            alt="Logo"
            class="logo q-pl-sm"
            fit="contain"
            crossorigin="*"
          />
          <q-img
            v-else
            fit="contain"
            src="../../../../assets/MULTPEX_VETOR.png"
            alt="Acciona Logo"
            class="logo q-pl-sm"
            crossorigin="*"
          />

          <p class="text-h6 text-bold q-pa-md titulo-ficha">
            LISTA DE PRESENÇA
          </p>
        </header>

        <div class="row data1 border-botom">
          <p class="q-pl-sm nome text-bold row items-center justify-center">
            <span>
              {{
                $store.state.autenticacao.cliente.toString().toUpperCase()
              }}</span
            >
          </p>
        </div>
        <div class="row data1">
          <div
            style="width: 25%"
            class="q-pl-sm borderleft text-bold row items-center"
          >
            <p>
              Nome Unidade:
              <span class="q-ml-sm" style="font-weight: normal">
                Unidade
                {{ dadosTabela?.unidadeId ? dadosTabela?.unidadeId : "" }}</span
              >
            </p>
          </div>
          <div style="width: 25%" class="q-pl-sm text-bold row items-center">
            <p>
              Nome do Treinamento:
              <span style="font-weight: normal">{{
                dadosTabela?.treinamentos[0]?.nome
              }}</span>
            </p>
          </div>
          <div
            style="width: 25%"
            class="q-pl-sm col text-bold row items-center"
          >
            <p>
              Reciclagem (Sim / Não):
              <span style="font-weight: normal">{{
                dadosTabela?.treinamentos[0]?.reciclagem == 1 ? "SIM" : "NÃO"
              }}</span>
            </p>
          </div>
          <div
            style="width: 25%"
            class="q-pl-sm col text-bold row items-center"
          >
            <p>
              Validade :
              <span style="font-weight: normal">{{
                dadosTabela?.treinamentos[0]?.validade
              }}</span>
            </p>
          </div>
        </div>
        <div style="border-top: 1px solid black" class="row data1">
          <div
            style="width: 25%"
            class="q-pl-sm borderleft text-bold row items-center"
          >
            <p>
              Nome da capacitação:
              <span style="font-weight: normal">{{
                dadosTabela?.descricao
              }}</span>
            </p>
          </div>
          <div style="width: 25%" class="q-pl-sm text-bold row items-center">
            <p>
              Nome e matricula instrutor:
              <span style="font-weight: normal"
                >{{ dadosTabela?.treinamentos[0]?.instrutor }} /
                {{ dadosTabela?.treinamentos[0]?.instrutorId }}</span
              >
            </p>
          </div>
          <div
            style="width: 25%"
            class="q-pl-sm col text-bold row items-center"
          >
            <div class="row">
              Assinatura instrutor:
              <div class="q-ml-sm">
                <q-img
                  v-if="dadosTabela?.treinamentos[0]?.instrutor_url_assinatura"
                  width="152px"
                  heigth="38px"
                  :src="dadosTabela?.treinamentos[0]?.instrutor_url_assinatura"
                />
                <span style="font-weight: normal" v-else
                  >Assinado Eletronicamente</span
                >
              </div>
            </div>
          </div>
          <div
            style="width: 25%"
            class="q-pl-sm col text-bold row items-center"
          >
            <p>
              Nome e matricula responsável:
              <span style="font-weight: normal">{{
                dadosCabecalho?.nome_responsavel
              }}</span>
            </p>
          </div>
        </div>
        <div style="border-top: 1px solid black" class="row data1">
          <div
            style="width: 50%"
            class="q-pl-sm col text-bold row items-center"
          >
            <div style="align-items: center" class="row">
              Assinatura responsável:
              <div class="q-ml-sm">
                <q-img
                  v-if="dadosCabecalho?.url_assinatura_responsavel"
                  width="152px"
                  heigth="38px"
                  :src="dadosCabecalho?.url_assinatura_responsavel"
                />
                <span style="font-weight: normal" v-else
                  >Assinado Eletronicamente</span
                >
              </div>
            </div>
          </div>
          <div
            style="width: 50%"
            class="q-pl-sm col text-bold row items-center"
          >
            <p>
              Data e hora aplicação capacitação:
              <span style="font-weight: normal">{{
                dadosTabela?.dataRealizacao?.split("-").reverse().join("/")
              }}</span>
            </p>
          </div>
        </div>
        <div class="row data2 border-botom">
          <div class="row DESCRIÇÃODOMATERIAL text-bold borderleft">
            <p style="width: 20%" class="row justify-center">
              Nome colaborador
            </p>

            <p style="width: 20%" class="row justify-center codigo3">
              Matricula Colaborador
            </p>
            <p style="width: 20%" class="row justify-center codigo3">
              Confirmação Presença (Sim/Não)
            </p>
            <p style="width: 20%" class="row justify-center codigo3">
              Data Confirmação
            </p>
            <p style="width: 20%" class="row justify-center codigo3">
              Assinatura
            </p>
          </div>
        </div>

        <div
          class="data3 row border-botom"
          v-for="(funcionario, index) in dadosTabela.funcionarios"
          :key="index"
          :class="{ quebra: index == 7 || (index - 7) % 15 == 0 }"
        >
          <div
            style="
              width: 20%;
              align-items: center;
              border-right: 1px solid black;
            "
            class="row justify-center"
          >
            {{ funcionario?.nome }}
          </div>
          <div
            style="
              width: 20%;
              align-items: center;
              border-right: 1px solid black;
            "
            class="row justify-center"
          >
            {{ funcionario?.usuarioId }}
          </div>
          <div
            style="
              width: 20%;
              align-items: center;
              border-right: 1px solid black;
            "
            class="row justify-center"
          >
            {{ funcionario?.presenca == 1 ? "SIM" : "NÃO" }}
          </div>
          <div
            style="
              width: 20%;
              align-items: center;
              border-right: 1px solid black;
            "
            class="row justify-center"
          >
            {{
              funcionario?.dataConfirmacao
                ?.split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}
            - {{ funcionario?.dataConfirmacao?.split(" ")[1] }}
          </div>

          <div
            style="width: 20%; align-items: center"
            class="row justify-center"
          >
            <q-img
              v-if="funcionario.authContent"
              width="152px"
              heigth="38px"
              style="height: 42px"
              :src="funcionario.authContent"
            />
            <span v-else>Assinado Eletronicamente</span>
          </div>
        </div>
      </main>
    </div>
    <div style="overflow: scroll" id="mobile">
      <main id="base-mobile" class="base q-ma-md">
        <header class="row headerBase">
          <q-img
            v-if="$store.state.autenticacao.logo.logoImpressao"
            :src="$store.state.autenticacao.logo.logoImpressao"
            alt="Multpex Logo"
            class="logo q-pl-sm"
            crossorigin="*"
            fit="contain"
          />
          <q-img
            v-else
            src="../../../../assets/MULTPEX_VETOR.png"
            alt="Acciona Logo"
            fit="contain"
            class="logo q-pl-sm"
          />

          <p class="text-h6 text-bold q-pa-md titulo-ficha">
            LISTA DE PRESENÇA
          </p>
        </header>
        <div class="row justify-center subHeader"></div>

        <div class="row q-pl-sm justify-center descricao"></div>
        <div class="row data1 border-botom">
          <p class="q-pl-sm nome text-bold row items-center">
            NOME: {{ dadosUsuario ? dadosUsuario.nome : "" }}
          </p>
          <p class="q-pl-sm função text-bold row items-center">
            MATRICULA: {{ dadosUsuario ? dadosUsuario.id : "" }}
          </p>
        </div>
        <div class="row data1"></div>
        <div class="row data2 border-botom">
          <div class="row column DESCRIÇÃODOMATERIAL borderleft">
            <p style="width: 50%" class="row codigo justify-center text-bold">
              CODIGO
            </p>
            <p class="row descricao2 justify-center text-bold">
              DESCRIÇÃO DO MATERIAL
            </p>
          </div>
          <div class="column col ENTREGA">
            <p class="row justify-center border-botom text-bold borderRight">
              ENTREGA
            </p>
            <div class="row">
              <div class="table1 borderRight">
                <p class="text text-bold">Nº DO PATRIMÔNIO</p>
              </div>

              <div class="table2 borderRight">
                <p class="text text-bold">ASSINATURA</p>
              </div>
              <div class="table3 borderRight">
                <p class="text text-bold">UNIDADE DE ENTREGA</p>
              </div>
              <div class="table4 borderRight">
                <p class="text text-bold">DATA ENTREGA</p>
              </div>
            </div>
          </div>
          <div class="column DEVOLUÇÃO">
            <p class="row justify-center border-botom text-bold">DEVOLUÇÃO</p>
            <div class="row">
              <div class="secondTable1 borderRight">
                <p class="text text-bold">Nº DO PATRIMÔNIO</p>
              </div>
              <div class="secondTable2 borderRight">
                <p class="text text-bold">ASSINATURA</p>
              </div>
              <div class="secondTable3 borderRight">
                <p class="text text-bold">DATA ENTREGA</p>
              </div>
              <div class="secondTable4">
                <p class="text text-bold">UNIDADE DEVOLUÇÃO</p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

import { useQuasar } from "quasar";

export default {
  setup() {
    const $route = useRoute();
    const quasar = useQuasar();

    const store = useStore();
    const dados = $route.params?.dados
      ? JSON.parse($route.params?.dados)
      : null;
    const dadosUsuario = ref("");
    const dadosCabecalho = ref({});
    const tabelas = ref([]);
    const funcionarioDado = ref({});
    const nome = ref("");
    const funcao = ref("");
    const registro = ref("");
    const dadosTabela = ref({ treinamentos: [] });
    let disable = ref(false);

    const realm = ref("");
    const quebras = ref([
      9, 22, 35, 48, 61, 74, 87, 100, 113, 126, 139, 152, 165, 178, 191,
    ]);
    const dadosFicha = ref({
      titulo: "",
      subtitulo: "",
      dizeres: "",
    });
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const getData = async () => {
      store.dispatch("pdt/hiddenHeader", false);

      try {
        const response = await store.dispatch(
          "treinamento/detalharCapacitacao",
          {
            capacitacao_id: dados.capacitacaoId,
          }
        );
        dadosTabela.value = response.data;
        getCabecalho();
      } catch (error) {
        quasar.notify({
          message: "Erro ao procurar dados.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getCabecalho = async () => {
      try {
        const response = await store.dispatch(
          "treinamento/detalharCabecalhoTreinamento",
          {
            capacitacao_id: dados.treinamentoId,
          }
        );
        dadosCabecalho.value = response.data.response;
      } catch (error) {
        quasar.notify({
          message: "Erro ao procurar dados.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(() => {
      getData();
    });

    return {
      tabelas,
      nome,
      dadosCabecalho,
      funcao,
      registro,
      realm,
      quebras,
      disable,
      dadosFicha,
      dadosUsuario,

      dadosTabela,

      funcionarioDado,
      mobile,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}

@page {
  size: A4 landscape;
}

.base {
  border: 1px solid black;
}

.base p {
  margin: 0px;
}

.data1 {
  font-size: 16px;
}

.headerBase {
  border-bottom: 1px solid black;
  display: flex;
}

.border-botom {
  border-bottom: 1px solid black;
}

.separador {
  height: 5px;
  border-bottom: 1px solid black;
}

.função {
  width: 65%;
}

.registro {
  width: 30%;
}

.data2 {
  border-top: 1px solid black;
}

.DESCRIÇÃODOMATERIAL {
  width: 100%;
  height: 40px;
  font-size: 14px;
  text-align: center;
}

.DESCRIÇÃODOMATERIAL p {
  height: 100%;
  align-items: center;
  justify-content: center;
}

.ENTREGA {
  width: 35%;
}

.DEVOLUÇÃO {
  width: 30%;
}

.unidade-entrega {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
}

.unidade-devolucao {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30%;
}

.borderRight {
  border-right: 1px solid black;
}

.text {
  text-align: center;
  word-wrap: break-word;
}

.table1 {
  display: flex;
  justify-content: center;
  width: 25%;
  align-items: center;
}

.table2 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
}

.table3 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
}

.codigo3 {
  border-left: 1px solid black;
  border-right: 1px solid black;
}

.table4 {
  display: flex;
  justify-content: center;
  width: 25%;
  align-items: center;
}

.biometria {
  height: 60px !important;
  width: 90px !important;
  object-fit: contain;
}
.secondTable1 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
}

.secondTable2 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
}

.secondTable3 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
}

.secondTable4 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
}
.border-top {
  border-top: 1px solid black;
}

.headerBase p {
  width: 79%;
  display: flex;
  justify-content: center;
}

.biometria {
  padding: 6px;

  width: 50px !important;
}

.subHeader {
  border-bottom: 1px solid black;
  font-weight: bolder;
}

.descricao {
  border-bottom: 1px solid black;
  height: 56px;
  align-items: center;
}

.data2 {
  font-size: 11px;
}
.nome {
  width: 100%;
}
.logo {
  margin-top: 5px;
  height: 50px;
  width: 180px;
}

.data3 {
  height: 50px;
}

.quebra {
  page-break-after: always;
}
@page {
  margin: 0.9mm;
  size: 290.7mm 210mm;
}
#desktop {
  display: block;
}
#mobile {
  display: none;
}

/* @media (max-width: 1000px) {
    .base p {
      font-size: 10px;
      margin: 0px;
      padding: 0px;
    }
  }
  @media (max-width: 800px) {
    .base p {
      font-size: 8px;
      margin: 0px;
      padding: 0px;
    }
  } */
@media (max-width: 600px) {
  /* #desktop {
      display: none;
    } */
  #mobile {
    display: block;
  }
}

@media print {
  .data1 {
    font-size: 12px;
  }
  .data2 {
    font-size: 10px;
  }

  .data3 {
    font-size: 8px;
  }
}
</style>
